import React from "react";
import { Navbar as BsNavbar, Container, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/core_semi_logo.jpeg";

const AppNavbar = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <BsNavbar expand="lg" sticky="top" className="pt-3 pb-3 bg-white shadow-sm">
      <Container>
        {/* Logo */}
        <BsNavbar.Brand
          as={NavLink}
      to="/"
          className="text-black"
          onClick={scrollToTop}
        >
          <img src={logo} alt="Chip Mentors" width="250px"/>
        </BsNavbar.Brand>

        <BsNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BsNavbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link
              as={NavLink}
              to="/"
              end
              className="nav-link-custom"
              onClick={scrollToTop}
            >
              Home
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/about"
              className="nav-link-custom"
              onClick={scrollToTop}
            >
              About
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/courses"
              className="nav-link-custom"
              onClick={scrollToTop}
            >
              Courses
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/careers"
              className="nav-link-custom"
              onClick={scrollToTop}
            >
              Careers
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/contact"
              className="nav-link-custom"
              onClick={scrollToTop}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
};

export default AppNavbar;
